import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  DashboardAccountCLABEContainer,
  Banner,
  DashboardAccountCLABEInfo,
  DashboardAccountCLABEButton,
  DashboardAccountCLABETable
} from './accountCLABE.styles';
import { API } from 'aws-amplify';
import ModalInfoVirtualAccount from 'src/components/shared/modals/infoVirtualAccount/infoVirtualAccount';
import ModalRegisterCLABE from 'src/components/shared/modals/registerCLABE/registerCLABE';
import ModalSuccessRegisterCLABE from 'src/components/shared/modals/successRegisterCLABE/successRegisterCLABE';
import { getInvestorBankAccount, getInvestor_Profile } from 'src/graphql/customized_queries';

export default function DashboardAccountCLABE() {
  const [infoVirtualAccount, setInfoVirtualAccount] = useState(false);
  const [registerCLABE, setRegisterCLABE] = useState(false);
  const [successRegisterCLABE, setSuccessRegisterCLABE] = useState(false);
  const [bankData, setbankData] = useState([]);
  const [personalInfo, setPersonalInfo] = useState({});
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await API.graphql({
          query: getInvestorBankAccount,
          variables: { id: user.id }
          // variables: { id: user[idKey] }
        });
        setbankData(data.getInvestor.banks.items);
      } catch (error) {
        console.error(error);
      }
    };
    if (user.id) {
      fetchUserData();
    }
  }, [user.id]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await API.graphql({
          query: getInvestor_Profile,
          variables: { id: user.id }
        });
        setPersonalInfo(data.getInvestor.personalInformation);
      } catch (error) {
        console.error(error);
      }
    };
    if (user.id) {
      fetchUserData();
    }
  }, [user.id]);

  const setStatus = (status) => {
    switch (bankData.status) {
      case 'inProgress':
        return 'En progreso';
      case 'rejected':
        return 'Rechazada';
      case 'approved':
        return 'Aprobada';
      default:
        return bankData.status;
    }
  };
  const openModal = () => {
    setRegisterCLABE(true);
  };
  const closeModal = () => {
    setRegisterCLABE(false);
  };
  return (
    <DashboardAccountCLABEContainer>
      <ModalInfoVirtualAccount showModalInfoVirtualAccount={infoVirtualAccount} />
      <ModalRegisterCLABE
        showModalRegisterCLABE={registerCLABE}
        closeModal={closeModal}
        bankData={bankData}
      />
      <ModalSuccessRegisterCLABE showModalSuccessRegisterCLABE={successRegisterCLABE} />
      <Banner>
        <h2>CLABES interbancarias</h2>
        <p>
          Aqui podrás encontrar toda la información de tus CLABES dadas de altas, así como su
          estatus.
        </p>
      </Banner>
      <DashboardAccountCLABEInfo>
        <div>
          <h3>Total de CLABES dadas de alta</h3>
          <h3>Total de CLABES activas</h3>
        </div>
        <div></div>
        <div>
          <p>1</p>
          <p>1</p>
        </div>
      </DashboardAccountCLABEInfo>
      <DashboardAccountCLABEButton>
        <button onClick={openModal}>Dar de alta una nueva CLABE</button>
      </DashboardAccountCLABEButton>
      <DashboardAccountCLABETable>
        <tbody>
          <tr>
            <th>Nombre</th>
            <th>Banco</th>
            <th>CLABE</th>
            <th>Cuenta Activa</th>
            <th>Cuenta principal</th>
          </tr>
          {bankData.map((bank, index) => (
            <tr key={index}>
              <td>{bank.identifier}</td>
              <td>{bank.bankName}</td>
              <td>{bank.CLABE}</td>
              <td>{setStatus(bank.status)}</td>
              <td>{bank.isMainAccount ? 'Sí' : 'No'}</td>
            </tr>
          ))}
        </tbody>
      </DashboardAccountCLABETable>
    </DashboardAccountCLABEContainer>
  );
}
